import { t } from '@/i18n';
import { BreadcrumbInfoItems } from 'src/components/SimpleBreadcrumb';

export const accessControlUserEditBreadcrumb: BreadcrumbInfoItems = [
  {
    label: t('pages.access_control_user_edit.breadcrumb.label1'),
    link: '/access-control',
  },
  {
    label: t('pages.access_control_user_edit.breadcrumb.label2'),
  },
];
